module.exports = "/lucky-balls/img/color_betting/brown.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/color_betting/brown.png
// module id = 978
// module chunks = 0